import { Switch } from "@headlessui/react";
import { isVisible } from "@testing-library/user-event/dist/utils";
import { Eye, EyeClosed } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ThreeDot } from "react-loading-indicators";
import { apiClient } from "../../../../api";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { baseUrl } from "../../../../Environments/environment";
const PMS_INTEGRATION_OPTIONS = [
  { value: "asiPms", label: "ASI PMS" },
  { value: "hotelKeyPms", label: "HotelKey PMS" },
];
const inputLabel = {
	pmsSelect: "Select PMS Name",
	clientId: "Client ID",
	save: "Save",
	pmsEnable: "Enable PMS Integration",
	applicationId: "Application ID",
	securityKey: "Security Key",
};

const pageLabel = {
	title: "PMS Integration",
};
function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}
const PmsIntegration = () => {
	const [pmsName, setPmsName] = useState("");
	const [clientId, setClientId] = useState("");
	const [applicationId, setApplicationId] = useState("");
	const [securityKey, setSecurityKey] = useState("");
	const [pmsEnabled, setPmsEnabled] = useState(false);
	const [loading, setLoading] = useState(true);
	const [setting, setSetting] = useState();
	const { selectedPropertyId } = useProperty();
	const [securityKeyVisible, setSecurityKeyVisible] = useState(false);
	const getSetting = async () => {
		try {
			setLoading(true);
			const response = await apiClient.get(
				`${baseUrl}/setting/${selectedPropertyId}`,
			);
			setSetting(response.data.result.setting);
			setPmsName(response.data.result.setting.pmsType || "");
			setClientId(response.data.result.setting.pmsId || "");
			setPmsEnabled(response.data.result.setting.pmsEnabled || false);
			setApplicationId(response.data.result.setting.asiApplicationId || "");
			setSecurityKey(response.data.result.setting.asiSecurityKey || "");

			console.log("Response from settings API:", response);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching settings:", error);
		} finally {
			setLoading(false);
		}
	};
	const handlePmsChange = (e) => {
		setPmsName(e.target.value);
	};
	const handleClientIdChange = (e) => {
		setClientId(e.target.value);
	};
	const handlePmsEnableChange = () => {
		alert(pmsEnabled);
		setPmsEnabled(!pmsEnabled);
	};
	const handleApplicationIdChange = (e) => {
		setApplicationId(e.target.value);
	};
	const handleSecurityKeyChange = (e) => {
		setSecurityKey(e.target.value);
	};
	const handleSave = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			const response = await apiClient.put(
				`${baseUrl}/setting/${selectedPropertyId}`,
				{
					pmsEnabled: pmsEnabled,
					pmsType: pmsName,
					pmsId: clientId,
					asiApplicationId: applicationId,
					asiSecurityKey: securityKey,
				},
			);
			if (response.status === 200) {
				setSetting(response.data.result);
				console.log("Settings saved successfully:", response.data.result);
			} else {
				console.error("Failed to save settings:", response);
			}
		} catch (error) {
			console.error("Error saving settings:", error);
		} finally {
			setLoading(false);
		}
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (selectedPropertyId) {
			getSetting();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedPropertyId]);

	return (
		<div className="bg-gray-100 p-12 flex justify-center">
			<div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 flex  flex-col w-full">
				<div className="flex items-center justify-between mb-4">
					<h2 className="text-2xl font-semibold">{pageLabel.title}</h2>
					{/**<div>
            {!loading && (
              <button
                className="bg-green-400 hover:bg-indigo-700 text-white font-medium px-4 py-2 rounded-md focus:outline-none"
                onClick={handleSave}
              >
                {inputLabel.save}
              </button>
            )}
          </div>*/}
				</div>
				{!loading ? (
					<form className="w-full mt-4">
						<div className="mb-4">
							<label
								htmlFor="pmsEnabled"
								className="block text-sm font-medium text-gray-700"
							>
								{inputLabel.pmsEnable}
							</label>
							<Switch
								checked={pmsEnabled}
								onChange={setPmsEnabled}
								className={classNames(
									pmsEnabled ? "bg-indigo-600" : "bg-gray-200",
									"mt-1 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
								)}
								disabled={true}
							>
								<span className="sr-only">Use setting</span>
								<span
									aria-hidden="true"
									className={classNames(
										pmsEnabled ? "translate-x-5" : "translate-x-0",
										"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
									)}
								/>
							</Switch>
						</div>

						<div className="mb-4">
							<label
								htmlFor="pmsName"
								className="block text-sm font-medium text-gray-700"
							>
								{inputLabel.pmsSelect}
							</label>
							<select
								id="pmsName"
								name="pmsName"
								className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 disabled:bg-gray-100 ${!pmsEnabled ? "bg-gray-100" : ""}`}
								defaultValue=""
								value={pmsName}
								required
								disabled={true}
								onChange={handlePmsChange}
							>
								<option value="" disabled>
									{inputLabel.pmsSelect}
								</option>
								{PMS_INTEGRATION_OPTIONS.map((option) => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
							</select>
						</div>
						<div className="mb-4">
							<label
								htmlFor="clientId"
								className="block text-sm font-medium text-gray-700"
							>
								{inputLabel.clientId}
							</label>
							<input
								type="text"
								id="clientId"
								name="clientId"
								className={`mt-1 block w-full rounded-md border-gray-300 disabled:bg-gray-100 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 ${!pmsEnabled ? "bg-gray-100" : ""}`}
								placeholder="Client ID"
								required
								minLength={1}
								value={clientId}
								disabled={true}
								onChange={handleClientIdChange}
							/>
						</div>
						<div className="mb-4">
							<label
								htmlFor="applicationId"
								className="block text-sm font-medium text-gray-700"
							>
								{inputLabel.applicationId}
							</label>
							<input
								type="text"
								id="applicationId"
								name="applicationId"
								className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 disabled:bg-gray-100 ${!pmsEnabled ? "bg-gray-100" : ""}`}
								placeholder="Application ID"
								disabled={true}
								required
								value={applicationId}
								onChange={handleApplicationIdChange}
							/>
						</div>
						<div className="mb-4">
							<label
								htmlFor="securityKey"
								className="block text-sm font-medium text-gray-700"
							>
								{inputLabel.securityKey}
							</label>
							<div>
								<div className="relative w-full">
									<input
										type={securityKeyVisible ? "text" : "password"}
										id="securityKey"
										name="securityKey"
										className={`mt-1 block w-full pr-10 rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 disabled:bg-gray-100 ${
											!pmsEnabled ? "bg-gray-100" : ""
										}`}
										placeholder="Security Key"
										disabled={true}
										required
										value={securityKey}
										onChange={handleSecurityKeyChange}
									/>
									<button
										type="button"
										className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
										onClick={() => setSecurityKeyVisible(!securityKeyVisible)}
									>
										{securityKeyVisible ? (
											<EyeClosed className="h-5 w-5 text-gray-400" />
										) : (
											<Eye className="h-5 w-5 text-gray-400" />
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				) : (
					<ThreeDot
						width={50}
						height={50}
						color="#4F46E5"
						variant="brick-stack"
					/>
				)}
			</div>
		</div>
	);
};
export default PmsIntegration;
